import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

const opts = {
  icons: {
    iconfont: 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  }
}

Vue.use(Vuetify)

export default new Vuetify(opts)



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js